import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home.component';
import { ComponentType, GoldenLayoutModule } from 'ngx-golden-layout';
import * as $ from 'jquery';
import { layoutComponentTypes } from './layout-types';
import { MapModule } from '../map/map.module';
import { ToolbarModule } from '../toolbar/toolbar.module';
import { DxPopupModule, DxScrollViewModule } from 'devextreme-angular';
import { TractorsGridModule } from '../tractors-grid/tractors-grid.module';
import { UserDomainsResolver } from '../user-domains/user-domains.resolver';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { UserDomainsInterceptor } from '../user-domains/user-domains.interceptor';
import { MapTractorsModule } from '../map-tractors/map-tractors.module';
import { MapFieldsModule } from '../map-fields/map-fields.module';
import { FieldsGridModule } from '../fields-grid/fields-grid.module';
import { WebsocketService } from '../services/websocket/websocket.service';
import { TrackersGridModule } from '../trackers-grid/trackers-grid.module';
import { TrailerOperationTypesGridModule } from '../trailer-operation-types-grid/trailer-operation-types-grid.module';
import { TrailersGridModule } from '../trailers-grid/trailers-grid.module';
import { ProfileEditFormModule } from '../../../../shared/src/lib/components/profile-edit-form/profile-edit-form.module';
import { TractorsHistoryModule } from '../tractors/tractors-history/tractors-history.module';
import { TrailerInterventionsGridModule } from '../trailer-interventions-grid/trailer-interventions-grid.module';
import { ReportsModule } from '../reports/reports.module';
import { FieldsReportModule } from '../fields-report/fields-report.module';
import { DashboardModule } from '../dashboard/dashboard.module';
import { TagsGridModule } from '../tags/tags-grid/tags-grid.module';
import { MapPoiModule } from '../map-poi/map-poi.module';
import { UsersGridModule } from '../users/users-grid/users-grid.module';
import { DriversGridModule } from '../drivers/drivers-grid/drivers-grid.module';
import { FieldEditorModule } from '../fields/field-editor/field-editor.module';
import { CropsGridModule } from '../crops/crops-grid/crops-grid.module';
import { FlowMeterReportPageModule } from '../fuel/flow-meter/flow-meter-report-page/flow-meter-report-page.module';
import { TransportInterventionsModule } from '../transport-interventions/transport-interventions.module';
import { RouterModule } from '@angular/router';
import { TransportInterventionsGridModule } from '../transport-interventions/transport-interventions-grid/transport-interventions-grid.module';
import { TransportInterventionsPageModule } from '../transport-interventions/transport-interventions-page/transport-interventions-page.module';
import { TanksGridModule } from '../tanks/tanks-grid/tanks-grid.module';
import { FieldsInterventionsPageModule } from '../fields-interventions/fields-interventions-page/fields-interventions-page.module';
import { SettingsResolver } from '../settings/settings.resolver';
import { TicketsGridModule } from '../tickets-grid/tickets-grid.module';
import { FieldsCropsGridModule } from '../fields-crops-grid/fields-crops-grid.module';
import { FieldEditorMapModule } from '../fields/field-editor-map/field-editor-map.module';
import { ReconstructedInterventionsGridModule } from '../reconstructed-interventions-grid/reconstructed-interventions-grid.module';
import { ParametersModule } from '../parameters/parameters.module';
// It is required to have JQuery as global in the window object.
// @ts-ignore
window['$'] = $;


@NgModule({
  declarations: [HomeComponent],
  imports: [
    CommonModule,
    MapModule,
    ToolbarModule,
    DxPopupModule,
    TractorsGridModule,
    TractorsHistoryModule,
    FieldsCropsGridModule,
    FieldsGridModule,
    TrackersGridModule,
    MapTractorsModule,
    MapFieldsModule,
    MapPoiModule,
    TrailerOperationTypesGridModule,
    TrailersGridModule,
    TrailerInterventionsGridModule,
    TransportInterventionsPageModule,
    FieldsInterventionsPageModule,
    TagsGridModule,
    ProfileEditFormModule,
    ReportsModule,
    FieldsReportModule,
    DashboardModule,
    UsersGridModule,
    DriversGridModule,
    FieldEditorModule,
    CropsGridModule,
    FlowMeterReportPageModule,
    TanksGridModule,
    TicketsGridModule,
    FieldEditorMapModule,
    ReconstructedInterventionsGridModule,
    ParametersModule,
    GoldenLayoutModule.forRoot(layoutComponentTypes),
    DxScrollViewModule,
    RouterModule,

  ],
  providers: [
    WebsocketService,
    UserDomainsResolver,
    SettingsResolver,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UserDomainsInterceptor,
      multi: true
    },
  ],
  exports: [HomeComponent]
})
export class HomeModule {
  constructor() {
  }
}
